import { render, staticRenderFns } from "./direction.vue?vue&type=template&id=08215cff&"
import script from "./direction.vue?vue&type=script&lang=js&"
export * from "./direction.vue?vue&type=script&lang=js&"
import style0 from "./direction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AutocompleteAirport: require('/opt/cargo.front/src/components/autocomplete/airport.vue').default,RzIconSwap: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-swap/index.js').default,BaseDatetimePicker: require('/opt/cargo.front/src/components/base/datetime-picker.vue').default,RzButton: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/button/index.js').default})
